(function () {
  'use strict';

  function initBtsSection(section) {
    if (!section) return;
    if (section.dataset.btsInitialized === 'true') return;
    section.dataset.btsInitialized = 'true';

    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    if (typeof Swiper !== 'undefined') {
      new Swiper('#nextdev--bts-swiper-' + sectionId, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        loop: false,
        navigation: {
          prevEl: '#nextdev--bts-prev-' + sectionId,
          nextEl: '#nextdev--bts-next-' + sectionId,
        },
        breakpoints: {
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 12,
            allowTouchMove: true,
          },
        },
      });
    }

    const cards = section.querySelectorAll('[data-video-card]');
    cards.forEach(function (card) {
      const video = card.querySelector('[data-video-element]');
      const playBtn = card.querySelector('[data-play-button]');
      const externalUrl = card.getAttribute('data-video-url');

      if (!playBtn) return;

      playBtn.addEventListener('click', function (e) {
        e.preventDefault();

        if (externalUrl && !video) {
          window.open(externalUrl, '_blank', 'noopener,noreferrer');
          return;
        }

        if (video) {
          if (video.paused) {
            video.muted = false;
            video.controls = true;
            video.play();
            card.classList.add('is-playing');
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        }
      });
    });
  }

  function initAllBtsSections() {
    const sections = document.querySelectorAll('[data-nextdev-bts]');
    sections.forEach(initBtsSection);
  }

  function waitForSwiperAndInit() {
    if (typeof Swiper !== 'undefined') {
      initAllBtsSections();
    } else {
      const iv = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          clearInterval(iv);
          initAllBtsSections();
        }
      }, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiperAndInit);
  } else {
    waitForSwiperAndInit();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-nextdev-bts]');
    if (section) {
      delete section.dataset.btsInitialized;
      waitForSwiperAndInit();
    }
  });
})();